import Post from './Post';
import NoPostsMessage from 'src/components/post/NoPostsMessage';
const { formatDate } = require('@itdeptutahcountygovernment/date-formatting');

function NewsFeed({ posts, onEditClick, onDeleteClick }) {
  return (
    <div className="min-vh-95 flex flex-col space-y-12">
      {posts?.length === 0 ? (
        <NoPostsMessage />
      ) : (
        posts.map((post, index) => (
          <Post
            cy-data="post"
            content={post.content}
            createdAt={formatDate(post.createdAt)}
            id={post.id}
            key={index}
            onDeleteClick={onDeleteClick}
            onEditClick={onEditClick}
            title={post.title}
            attachments={post.attachments}
            link={post.videoLink}
          />
        ))
      )}
    </div>
  );
}

export default NewsFeed;
